export default "__VITE_PUBLIC_ASSET__7edf8a3d__"